module.exports = "<p>\n  shipstation-orders-details works!\n</p>\n"